import range from 'lodash/range';

import { getClosestTimeSteps } from './TimingUtils';

// ACTION TYPES
export const TIMING_SET_BUFFER_SIZE = 'TIMING_SET_BUFFER_SIZE';
export const TIMING_UPDATE_BUFFER = 'TIMING_UPDATE_BUFFER';
export const TIMING_TOGGLE_BUFFER_STATUS = 'TIMING_TOGGLE_BUFFER_STATUS';
export const TIMING_SET_PLAYING = 'TIMING_SET_PLAYING';
export const TIMING_SET_TIMESTAMP = 'TIMING_SET_TIMESTAMP';
export const TIMING_SET_VISIBLE_TIMESTAMP = 'TIMING_SET_VISIBLE_TIMESTAMP';
export const TIMING_SET_TIMENAVIGATION = 'TIMING_SET_TIMENAVIGATION';
export const TIMING_SET_IDLEMODE = 'TIMING_SET_IDLEMODE';

let playTimeout = null;
// ACTIONS
export function updateBufferStatus(tileIndex) {
  return { type: TIMING_UPDATE_BUFFER, tileIndex };
}

export function setBufferSize(size) {
  return { type: TIMING_SET_BUFFER_SIZE, size };
}

export function toggleBufferStatus() {
  return { type: TIMING_TOGGLE_BUFFER_STATUS };
}

export function setPlaying(isPlaying) {
  return { type: TIMING_SET_PLAYING, isPlaying };
}

export function setTimeStep(timestamp) {
  return { type: TIMING_SET_TIMESTAMP, timestamp };
}

export function setVisibleTimeStamp(timestamp) {
  return { type: TIMING_SET_VISIBLE_TIMESTAMP, timestamp };
}

export function stopPlaying() {
  return setPlaying(false);
}

export function animate() {
  return (dispatch, getState) => {
    if (playTimeout) {
      window.clearTimeout(playTimeout);
    }

    const { TimingState: { currentTimestamp, timeNavigation, tilesLoaded, isPlaying, idleMode } } = getState();

    // check if the next ts is in range of avail timesteps
    const isOutOfRange = currentTimestamp + timeNavigation.step > timeNavigation.max;
    // calc next ts or set ts to the first one of available timesteps
    const nextTimeStamp = isOutOfRange ? timeNavigation.min : currentTimestamp + timeNavigation.step;

    if (!isPlaying) {
      return false;
    }

    // check if in play mode the nextTimeStamp is already buffered, if not stop playing
    const closeTsIndex = getClosestTimeSteps(timeNavigation.timesteps, nextTimeStamp).nearestTimestep.index;
    if (closeTsIndex === undefined || !tilesLoaded[closeTsIndex]) {
      console.error('stop Playing | ' + closeTsIndex + ' not loaded | idleMode: ' + idleMode);
      dispatch(stopPlaying());
      return false;
    }
    const lastItem = closeTsIndex === timeNavigation.timesteps.length - 1;
    console.info('%c ' + currentTimestamp + ' -> ' + nextTimeStamp, 'background:green;color:white;');

    dispatch(setVisibleTimeStamp(nextTimeStamp));
    dispatch(setTimeStep(nextTimeStamp));

    playTimeout = window.setTimeout(() => dispatch(animate()), lastItem ? timeNavigation.animationSpeed * 2 : timeNavigation.animationSpeed);
  };
}

export function resumeAnimation() {
  return dispatch => {
    dispatch(animate());
  };
}

export function clearAnimation() {
  return () => {
    window.clearTimeout(playTimeout);
  };
}

export function togglePlaying() {
  return (dispatch, getState) => {
    dispatch(setPlaying(!getState().TimingState.isPlaying));
    dispatch(animate());
  };
}

function buildTimeNavigation(params) {
  const timesteps = params.runs[0].timesteps;
  const min = +new Date(timesteps[0].date);
  const max = +new Date(timesteps[timesteps.length - 1].date);
  const now = +new Date();
  let init = init = +new Date(getClosestTimeSteps(timesteps, now).nearestTimestep.date);
  if (now < min) {
    init = min;
  } else if (now > max) {
    init = max;
  }

  const prognose = timesteps.map((timestep, index) =>
    (timestep.flag && timestep.flag === 'Prognose' ? index : null)
  ).filter(item => item !== null);
  const prognoseAfterTimestamp = prognose.length ? +new Date(timesteps[prognose[0]].date) : null;

  return {
    min,
    max,
    step: Math.floor((max - min) / (timesteps.length - 1)),
    initial: init,
    animate: false,
    animationSpeed: 500,
    prognose,
    prognoseAfterTimestamp,
    timesteps
  };
}

export function setTimeNavigation(payload) {
  const timeNavigation = buildTimeNavigation(payload);
  return { type: TIMING_SET_TIMENAVIGATION, timeNavigation };
}

export function setIdleMode(isIdleMode) {
  return { type: TIMING_SET_IDLEMODE, isIdleMode };
}

export const actions = {
  setBufferSize,
  updateBufferStatus,
  togglePlaying,
  setTimeStep,
  setVisibleTimeStamp,
  setTimeNavigation,
};

// REDUCER
const initialState = {
  currentTimestamp: null,
  visibleTimestamp: null,
  isPlaying: false,
  tilesLoaded: [],
  isBuffering: false,
  initialBufferLoadCount: window.maptoolConfig && window.maptoolConfig.isPortable ? 1 : 5,
  idleMode: true, // we set this false when user interacts with the time control the first time
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TIMING_SET_BUFFER_SIZE: {
      // create array with false (not loaded) values for each step
      const tilesLoaded = range(action.size).map(() => false);
      return Object.assign({}, state, { tilesLoaded });
    }
    case TIMING_UPDATE_BUFFER: {
      const tilesLoaded = state.tilesLoaded.slice(0);
      tilesLoaded[action.tileIndex] = true;

      return Object.assign({}, state, { tilesLoaded });
    }
    case TIMING_TOGGLE_BUFFER_STATUS:
      return Object.assign({}, state, { isBuffering: !state.isBuffering });
    case TIMING_SET_PLAYING:
      return Object.assign({}, state, { isPlaying: action.isPlaying });
    case TIMING_SET_TIMESTAMP:
      return Object.assign({}, state, {
        currentTimestamp: action.timestamp
      });
    case TIMING_SET_VISIBLE_TIMESTAMP:
      return Object.assign({}, state, { visibleTimestamp: action.timestamp });
    case TIMING_SET_TIMENAVIGATION: {
      return Object.assign({}, state, { timeNavigation: action.timeNavigation, currentTimestamp: action.timeNavigation.initial, visibleTimestamp: action.timeNavigation.initial });
    }
    case TIMING_SET_IDLEMODE: {
      return Object.assign({}, state, { idleMode: action.isIdleMode });
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimingState.js
 **/